<ng-container *ngIf="relipayConfig.layout.style === 'relipay-distributer-template' && isLoad">


    <relipay-template></relipay-template>
    <app-loader></app-loader>
</ng-container>
<div class="trustedsite-trustmark" data-type="106" data-width="100" data-height="41"></div>
